module.exports = __webpack_public_path__ + "static/media/logo_fr.cdeb3ba5.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/logo_fr.png
// module id = 512
// module chunks = 0